import script from "./Title.vue?vue&type=script&setup=true&lang=js"
export * from "./Title.vue?vue&type=script&setup=true&lang=js"

import "./Title.vue?vue&type=style&index=0&id=6df3d3d7&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df3d3d7"]])

export default __exports__